var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"code-editor"},[(_vm.label)?_c('label',{staticClass:"code-editor__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('codemirror',{ref:"cm",attrs:{"value":_vm.value,"options":_vm.cmOptions},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }